import { render, staticRenderFns } from "./RevitOnboardingSteps.vue?vue&type=template&id=1721b642"
import script from "./RevitOnboardingSteps.vue?vue&type=script&lang=ts"
export * from "./RevitOnboardingSteps.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports